import React, { useState } from 'react';
import { Button } from '../../ui/Button';
import { Alert } from '../../ui/Alert';

export const DeleteMomentModal = ({ moment, onConfirm, onClose }) => {
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState('');

  const handleConfirm = async () => {
    setDeleting(true);
    setError('');
    try {
      await onConfirm();
    } catch (err) {
      setError(err.message || 'Could not move this moment to Trash.');
      setDeleting(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 p-4">
      <div className="bg-white w-full max-w-sm rounded-3xl p-6 space-y-4 shadow-xl">
        <h2 className="text-xl font-bold text-slate-900 tracking-tight">Move to Trash?</h2>
        <p className="text-sm text-slate-600">
          <span className="font-bold">{moment.title || 'This moment'}</span> will move to Trash. You can restore it within 30 days. After that it is permanently deleted.
        </p>
        {error && <Alert variant="error" message={error} />}
        <div className="flex justify-end gap-3">
          <Button variant="secondary" onClick={onClose} disabled={deleting}>Cancel</Button>
          <Button variant="danger" onClick={handleConfirm} isLoading={deleting}>Move to Trash</Button>
        </div>
      </div>
    </div>
  );
};